import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const today = () => new Date().toISOString().split('T')[0];
const InputField = ({
    name,
    id,
    type,
    placeholder,
    value,
    label,
    error,
    info,
    onChange,
    disabled,
    required,
    onBlur,
    onKeyUp,
    min,
    max,
    step,
    inputMode,
    autoFocus,
}) => {
  const effectiveMax = type === 'date' && max === undefined ? today() : max;
  return (
    <div className="form-group">
        {label && (
          <label className='form-label'>{label}{required && <span className="text-danger ms-1">*</span>}</label>
        )}
        <input type={type} className={classnames('form-control', {'is-invalid' : error})} name={name} id={id} value={value} placeholder={placeholder} onChange={onChange} disabled={disabled} required={required} onBlur={onBlur} onKeyUp={onKeyUp} min={min} max={effectiveMax} step={step} inputMode={inputMode} autoFocus={autoFocus} aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
        {info && <small className='form-text text-muted'>{info}</small>}
        {error && <div className="invalid-feedback mb-2" style={{textAlign: 'left'}}>{error}</div>}
    </div>
  )
}

const NullableInput = ({
  name,
  id,
  type,
  placeholder,
  value,
  label,
  error,
  info,
  onChange,
  onBlur,
  disabled,
  required,
  onKeyUp,
  min,
  max,
  step,
  inputMode,
  autoFocus,
}) => {
const effectiveMax = type === 'date' && max === undefined ? today() : max;
return (
  <div className="form-group">
      {label && (
        <label className='form-label'>{label}{required && <span className="text-danger ms-1">*</span>}</label>
      )}
      <input
        type={type}
        className={classnames('form-control', {'is-invalid' : error})}
        name={name}
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
        disabled={disabled}
        required={required}
        min={min}
        max={effectiveMax}
        step={step}
        inputMode={inputMode}
        autoFocus={autoFocus}
        aria-label="Default"
        aria-describedby="inputGroup-sizing-default"
      />
      {info && <small className='form-text text-muted'>{info}</small>}
      {error && <div className="invalid-feedback mb-2" style={{textAlign: 'left'}}>{error}</div>}
  </div>
)
}

InputField.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date), PropTypes.object]).isRequired,
    label: PropTypes.string,
    error: PropTypes.string,
    info: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onKeyUp: PropTypes.func,
    onBlur: PropTypes.func,
    disabled: PropTypes.string,
    required: PropTypes.string,
}

NullableInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  error: PropTypes.string,
  info: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onKeyUp: PropTypes.func,
  disabled: PropTypes.string,
  required: PropTypes.string
}

InputField.defaultProps = {
    type: 'text'
}

NullableInput.defaultProps = {
  type: 'text'
}

export {InputField, NullableInput}
